import React from 'react';
import './Establish.css'
import WA from './WA/WA'


const Establish = () => {

return (
    <div className="establish-container">
<WA/>

    </div>
)


}




export default Establish;